import { Avatar, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Pagination, Stack, Typography } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import ApiLink from 'API';
import axios from 'axios';
import { useNavigate } from 'react-router';
import SubCard from 'ui-component/cards/SubCard';
import StyledDataGrid from 'ui-component/StyledDataGrid';
import { Box } from '@mui/system';
import moment from 'moment';
import ArrowCircleDown from '@mui/icons-material/ArrowCircleDownRounded';
import ArrowCircleUp from '@mui/icons-material/ArrowCircleUpRounded';
import ImageIcon from '@mui/icons-material/Image';
import NumberFormat from 'react-number-format';
import ImagePreview from 'ui-component/ImagePreview';
import MessageBox from 'ui-component/MessageBox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ViewInoice from './ViewInoice';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import oneproofQrBg from 'assets/images/oneproof-qr-bg.png';
import oneproof from 'assets/images/oneproof.svg';
import OneProofSlipCard from 'ui-component/cards/OneProofSlipCard';
import StickerOnproof from 'ui-component/StickerOnproof';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ViewInoiceCreditNote from 'views/financial/aoneWallet/credit/ViewInoiceCreditNote';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ViewInoiceCreditInvoice from 'views/financial/creditInvoice/ViewInoiceCreditInvoice';
import ViewInoiceWithdrawal from 'views/financial/aoneWallet/withdraw/ViewInoiceWithdrawal';

const StatementHistory = ({ open, setOpen }) => {
    const isMounted = useRef(true);
    const [OpenInvoice, setOpenInvoice] = useState(false);
    const [SelectData, setSelectData] = useState({});
    const [OpenInvoiceCreditNote, setOpenInvoiceCreditNote] = useState(false);
    const [SelectDataCreditNote, setSelectDataCreditNote] = useState({});
    const [OpenInvoiceCreditInvoice, setOpenInvoiceCreditInvoice] = useState(false);
    const [SelectDataCreditInvoice, setSelectDataCreditInvoice] = useState({});
    const [openBackdrop, setopenBackdrop] = useState(false);
    const navigate = useNavigate();
    const [StatementsHistory, setStatementsHistory] = useState([]);
    const [totalPage, settotalPage] = useState(0);
    const [total, settotal] = useState(0);
    const [page, setpage] = useState(1);
    const [ViewWithdrawal, setViewWithdrawal] = useState(false);

    useEffect(() => {
        isMounted.current = true;
        return () => { isMounted.current = false; };
    }, []);

    const PreviewInvoiceWithdrawal = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const response = await axios.get(ApiLink + '/api/aonewallet/withdrawal/invoice/' + Requestid, {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });
            if (isMounted.current) {
                if (response.status === 200) {
                    if (response.data.data.length !== 0) {
                        setSelectData(response.data?.data[0]);
                        setViewWithdrawal(true);
                    }
                } else if (response.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
            }
        } catch (error) {
            if (isMounted.current) {
                if (error?.response?.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
                console.log(error);
            }
        }
        if (isMounted.current) setopenBackdrop(false);
    };

    const PreviewVerifyOneProof = async (OneProofData) => {
        MessageBox.open({
            title: 'Preview',
            content: Object.keys(OneProofData).length !== 0 && (
                <Grid container spacing={2}>
                    <Grid item xs={12} align="center">
                        <OneProofSlipCard OneProofData={OneProofData} />
                    </Grid>
                </Grid>
            ),
            buttons: [{ name: 'Close', handler: () => true }]
        });
    };

    const PreviewImageReference = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const response = await axios.get(ApiLink + '/api/users/aonewallet/statementsimage/' + Requestid, {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });

            if (isMounted.current) {
                if (response.status === 200) {
                    MessageBox.open({
                        title: 'Preview',
                        content: <ImagePreview images={[response.data.data[0]?.referenceImage]} />,
                        buttons: [{ name: 'Close', handler: () => '' }]
                    });
                } else if (response.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
            }
        } catch (error) {
            console.log(error);
        }
        if (isMounted.current) setopenBackdrop(false);
    };

    const PreviewInvoice = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const response = await axios.get(ApiLink + '/api/users/aonewallet/invoice/' + Requestid, {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });
            if (isMounted.current) {
                if (response.status === 200) {
                    setSelectData(response.data?.data);
                    setOpenInvoice(true);
                } else if (response.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
            }
        } catch (error) {
            console.log(error);
        }
        if (isMounted.current) setopenBackdrop(false);
    };

    const PreviewInvoiceCreditNote = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const response = await axios.get(ApiLink + '/api/aonewallet/credit/invoice/' + Requestid, {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });
            if (isMounted.current) {
                if (response.status === 200) {
                    if (Object.keys(response.data.data).length !== 0) {
                        setSelectDataCreditNote(response.data?.data);
                        setOpenInvoiceCreditNote(true);
                    }
                } else if (response.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
            }
        } catch (error) {
            if (isMounted.current) {
                if (error?.response?.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
                console.log(error);
            }
        }
        if (isMounted.current) setopenBackdrop(false);
    };

    const PreviewInvoiceCreditInvoice = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const response = await axios.get(ApiLink + '/api/aonewallet/creditinvoice/invoice/' + Requestid, {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });
            if (isMounted.current) {
                if (response.status === 200) {
                    if (Object.keys(response.data.data).length !== 0) {
                        setSelectDataCreditInvoice(response.data?.data);
                        setOpenInvoiceCreditInvoice(true);
                    }
                } else if (response.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
            }
        } catch (error) {
            if (isMounted.current) {
                if (error?.response?.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
                console.log(error);
            }
        }
        if (isMounted.current) setopenBackdrop(false);
    };

    const handlePage = (event, value) => {
        setpage(value);
    };

    useEffect(() => {
        const LoadStatements = async () => {
            try {
                setopenBackdrop(true);
                const response = await axios.get(ApiLink + '/api/users/aonewallet/statements/' + page, {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (isMounted.current) {
                    if (response.status === 200) {
                        setStatementsHistory(response.data.data || []);
                        settotal(response.data.total || 0);
                        settotalPage(response.data.totalPage || 0);
                    } else if (response.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            } catch (error) {
                if (isMounted.current) {
                    console.log(error);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            }
            if (isMounted.current) setopenBackdrop(false);
        };
        if (open) LoadStatements();
    }, [page, open, navigate]);

    const handleClose = () => {
        setOpen(false);
    };

    const columns = [
        {
            field: 'status',
            headerName: '',
            width: 50,
            sortable: false,
            filterable: false,
            headerAlign: 'center',
            align: 'right',
            renderCell: (params) => (
                <Typography variant="button" noWrap gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.status === 'in' ? (
                        <ArrowCircleDown sx={{ color: 'green' }} />
                    ) : params.row.status === 'out' ? (
                        <ArrowCircleUp sx={{ color: 'red' }} />
                    ) : (
                        <DoNotDisturbOnIcon sx={{ color: 'gray' }} />
                    )}
                </Typography>
            )
        },
        {
            field: 'Reference',
            headerName: 'reference',
            width: 160,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Stack alignItems="center" justifyContent="center">
                        <Typography variant="body2" noWrap gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                            {params.row.reference}
                        </Typography>
                        {params.row.status === 'in' ? (
                            <Button
                                aria-label="Image"
                                onClick={() => {
                                    params.row?.verify === 'oneproof'
                                        ? PreviewVerifyOneProof(params.row?.oneProof)
                                        : params.row?.verify === 'credit'
                                        ? PreviewInvoiceCreditNote(params.row?.reference)
                                        : params.row?.type === 'credit-invoice'
                                        ? PreviewInvoiceCreditInvoice(params.row?.reference)
                                        : PreviewImageReference(params.row._id);
                                }}
                            >
                                {params.row?.verify === 'oneproof' ? (
                                    <StickerOnproof />
                                ) : params.row?.verify === 'credit' ? (
                                    <CardGiftcardIcon sx={{ width: 32, height: 32 }} />
                                ) : params.row?.type === 'credit-invoice' ? (
                                    <CreditCardIcon sx={{ width: 32, height: 32 }} />
                                ) : (
                                    <ImageIcon sx={{ width: 32, height: 32 }} />
                                )}
                            </Button>
                        ) : params.row.status === 'out' ? (
                            <IconButton
                                color="primary"
                                aria-label="Image"
                                onClick={() => {
                                    if (params.row.type?.toLowerCase() === 'withdrawal') {
                                        PreviewInvoiceWithdrawal(params.row.invoiceNumber);
                                    } else {
                                        PreviewInvoice(params.row.invoiceNumber);
                                    }
                                }}
                            >
                                <VisibilityIcon sx={{ width: 32, height: 32 }} />
                            </IconButton>
                        ) : params.row.status === 'cancel' ? (
                            <IconButton
                                color="default"
                                aria-label="Image"
                                onClick={() => {
                                    params.row?.verify === 'oneproof'
                                        ? PreviewVerifyOneProof(params.row?.oneProof)
                                        : params.row?.verify === 'credit'
                                        ? PreviewInvoiceCreditNote(params.row?.reference)
                                        : params.row?.type === 'credit-invoice'
                                        ? PreviewInvoiceCreditInvoice(params.row?.reference)
                                        : PreviewImageReference(params.row._id);
                                }}
                            >
                                {params.row?.verify === 'oneproof' ? (
                                    <StickerOnproof />
                                ) : params.row?.verify === 'credit' ? (
                                    <CardGiftcardIcon sx={{ width: 32, height: 32 }} />
                                ) : params.row?.type === 'credit-invoice' ? (
                                    <CreditCardIcon sx={{ width: 32, height: 32 }} />
                                ) : (
                                    <ImageIcon sx={{ width: 32, height: 32 }} />
                                )}
                            </IconButton>
                        ) : null}
                    </Stack>
                );
            }
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 200,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Typography variant="body2" noWrap gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.description}
                </Typography>
            )
        },
        {
            field: 'createdAt',
            headerName: 'createdAt',
            width: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Typography variant="body2" noWrap gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {moment(params.row.createdAt).format('DD-MM-yyyy HH:mm')}
                    </Typography>
                );
            }
        },
        {
            field: 'totalPayment',
            headerName: 'Payment',
            width: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Stack>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: params.row.status === 'in' ? 'green' : params.row.status === 'out' ? 'red' : 'gray'
                        }}
                    >
                        {params.row.status === 'out' ? '-' : ''}
                        <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={params.row.totalPayment}
                            prefix="₭"
                            decimalSeparator="."
                            displayType="text"
                            thousandSeparator={true}
                            allowNegative={true}
                        />
                    </Typography>
                </Stack>
            )
        },
        {
            field: 'ApproveBy',
            headerName: 'ApproveBy',
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Typography variant="body2" noWrap gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.users?.fullname}
                </Typography>
            )
        }
    ];

    return (
        <div>
            <Dialog
                fullWidth
                maxWidth="md"
                open={open}
                onClose={handleClose}
                scroll="paper"
                disableEnforceFocus
            >
                <ViewInoiceWithdrawal Open={ViewWithdrawal} setOpen={setViewWithdrawal} DataInvoice={SelectData} />
                <ViewInoiceCreditNote Open={OpenInvoiceCreditNote} setOpen={setOpenInvoiceCreditNote} DataInvoice={SelectDataCreditNote} />
                <ViewInoiceCreditInvoice
                    Open={OpenInvoiceCreditInvoice}
                    setOpen={setOpenInvoiceCreditInvoice}
                    DataInvoice={SelectDataCreditInvoice}
                />
                <ViewInoice setOpen={setOpenInvoice} Open={OpenInvoice} DataInvoice={SelectData} />
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="subtitle1">
                        Statements{' '}
                        {localStorage.getItem('branchCode') || ''}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers={true} sx={{ minHeight: '75vh', maxHeight: '75vh', mb: 2 }}>
                    <div id="app-message-box" />
                    <SubCard show={true} title="Aone Wallet Statements" contentSX={{ p: 0 }}>
                        <Box sx={{ width: '100%', height: '80vh', textAlign: 'center', border: 0, borderRadius: 16 }}>
                            <StyledDataGrid
                                loading={openBackdrop}
                                getRowId={(row) => row._id}
                                rows={StatementsHistory}
                                columns={columns}
                                rowHeight={100}
                                headerHeight={60}
                                hideFooter={true}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', pt: '5px' }}>
                            <Pagination
                                disabled={openBackdrop}
                                count={totalPage}
                                page={page}
                                size="small"
                                shape="rounded"
                                color="primary"
                                onChange={handlePage}
                                showFirstButton
                                showLastButton
                            />
                        </Box>
                        <Typography variant="caption" sx={{ display: 'flex', justifyContent: 'center', pt: '5px', fontSize: '10px' }}>
                            Total : {total}
                        </Typography>
                    </SubCard>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default StatementHistory;
